export const defaultAppConfig = {
  app_name: "Color Explorer",
  app_description: "Color Explorer is a modern, minimal web tool designed for product designers, frontend engineers, branding teams, and students to rapidly build and test color palettes for accessibility. With support for HEX, RGB, and HSL inputs, automatic WCAG contrast matrices with live gradient cells, real-time previews, clear AA/AAA pass-fail badges, and shareable URL-encoded states—all without any sign-ups or accounts—Color Explorer empowers you to craft accessible, on-brand designs instantly.",
  app_tagline: "Instant Accessible Color Palettes",
  production: process.env.NODE_ENV === "production",
  app_url: process.env.APP_URL || "",
  app_id: process.env.APP_ID || "",
  
  app_logo_url_light:
    "https://app-assets.constructr.ai/e289c5cd-8ee5-4712-a86d-87874e63490a/branding/logo-light.png",
  app_logo_url_dark:
    "https://app-assets.constructr.ai/e289c5cd-8ee5-4712-a86d-87874e63490a/branding/logo-dark.png",

  app_full_logo_url_light:
    "https://app-assets.constructr.ai/e289c5cd-8ee5-4712-a86d-87874e63490a/branding/logo-full-light.png",
  app_full_logo_url_dark:
    "https://app-assets.constructr.ai/e289c5cd-8ee5-4712-a86d-87874e63490a/branding/logo-full-dark.png",

  app_badge_show: true,
  app_badge_href: "https://constructr.ai?utm_source=badge&utm_campaign=badge",
  app_badge_src: "https://assets.constructr.ai/images/made-with-badge.png",
  app_badge_alt: "Made with Constructr",
  allow_remix: false
};



